var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.btn.id + '-container'}},[(_vm.btn.custom)?_c('div',{class:_vm.btn.className,attrs:{"id":_vm.btn.id}},[_vm._t("default")],2):_c('button',{class:_vm.btn.className,attrs:{"id":_vm.btn.id,"title":"按住ctrl键选择多个文件可同时上传"}},[_vm._t("default"),_vm._v(_vm._s(_vm.btn.title)+" ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }